export enum InsightPanelSize {
  small = 'small',
  medium = 'medium',
}
